// @flow
import {
  applyMiddleware,
  compose,
  combineReducers,
  createStore as createReduxStore,
} from "redux";
import thunk from "redux-thunk";

import { routerMiddleware } from "../_router/RouterMiddleware";
import { modularUIMiddleware } from "../_modularui/ModularUIMiddleware";

import { createReducer } from "../reducers/createReducer";
import { locationChange } from "../_router/RouterActions";

import type { RouterHistory } from "react-router";
import type { ReduxAction, ReduxState, ReduxStore } from "../types";
import type { Reducer } from "redux";

type ThunkExtra = {
  subscribe?: $PropertyType<ReduxStore, "subscribe">,
};

/**
 */
const configureStore = (
  routerHistory: RouterHistory,
  customReducers?: Object,
  initialState?: $Shape<ReduxState>,
): { routerHistory: RouterHistory, store: ReduxStore } => {
  let composeEnhancers = compose;

  if (process.env.NODE_ENV !== "production" && typeof window !== "undefined") {
    composeEnhancers =
      // $FlowIssue
      globalThis.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  }

  // $FlowIssue
  const thunkExtra: ThunkExtra = {};

  const combinedReducers: Reducer<ReduxState, ReduxAction> = combineReducers({
    ...customReducers,
    ...createReducer(),
  });

  const middleware = applyMiddleware(
    modularUIMiddleware,
    routerMiddleware(routerHistory),
    thunk.withExtraArgument(thunkExtra),
  );

  const enhancers = composeEnhancers(middleware);

  const store: ReduxStore = createReduxStore(
    combinedReducers,
    initialState,
    enhancers,
  );

  // Populate the extra argument with the store's subscribe method -> use to wait on store updates
  thunkExtra.subscribe = store.subscribe;

  if (!initialState?.router) {
    store.dispatch(locationChange(routerHistory.location, "PUSH"));
  }

  return { routerHistory, store };
};

export default configureStore;
